"use strict";
import R from "ramda";
import inside from "point-in-polygon";
import AnnotationComponents from "./components";
import DragPoint from "./drag_point";
export function isPointIn(p, polygon) {
  const point = [p.x, p.y];
  return inside(point, polygon);
}
export const hoverFor = (mousePos) => (typeID, dragPoints) => {
  const Comp = AnnotationComponents[typeID];
  const hoveredDragPointIndex = R.findIndex(
    DragPoint.isPointIn(mousePos),
    dragPoints
  );
  const isIndex = R.is(Number, hoveredDragPointIndex) && hoveredDragPointIndex >= 0;
  return {
    hovered: isPointIn(mousePos, Comp.getBoundingBox(dragPoints)) || isIndex,
    dragPointIndex: isIndex ? hoveredDragPointIndex : false
  };
};
